import { atom } from "recoil";
import { LicenseTypeInfo } from "../types/index"

export const addStateLicenseType = atom({
  key: "addStateLicenseType",
  default: false,
});
export const editStateLicenseType = atom({
  key: "editStateLicenseType",
  default: false,
});

export const selectedRowsStateLicenseType = atom<LicenseTypeInfo[]>({
  key: "selectedRowsStateLicenseType",
  default: [],
});

export const filterText = atom({
  key: "filterText",
  default: "",
});

export const selectedRowsToDelete = atom< undefined | []>({
  key: "selectedRowsToDelete",
  default: [],
});

export const rowEditIdStateLicenseType = atom({
  key: "rowEditIdLicenseType",
  default: null,
});

export const rowForEditLicenseType = atom<LicenseTypeInfo | undefined>({
    key: "rowForEditLicenseType",
    default: undefined,
  });
  
export const licenseTypeSaving = atom({
    key: "LicenseTypeSaving",
    default: false,
  });

export const disableButtonStateLicenseType = atom({
    key: "disableButtonLicenseType",
    default: false,
  });